import * as THREE from 'three'

// Strike Zone
const zone_width = 20 / 12
const inner_zone_width = zone_width - 2 / 12
const zone_height = 24 / 12
const inner_zone_height = 24 / 12 - 2 / 12
const zone_center = 2.5

const zone_shape = new THREE.Shape()
    .moveTo(-zone_width / 2, -zone_height / 2)
    .lineTo(-zone_width / 2, zone_height / 2)
    .lineTo(zone_width / 2, zone_height / 2)
    .lineTo(zone_width / 2, -zone_height / 2)
    .lineTo(-zone_width / 2, -zone_height / 2)

const hole = new THREE.Path()
    .moveTo(-inner_zone_width / 2, -inner_zone_height / 2)
    .lineTo(inner_zone_width / 2, -inner_zone_height / 2)
    .lineTo(inner_zone_width / 2, inner_zone_height / 2)
    .lineTo(-inner_zone_width / 2, inner_zone_height / 2)
    .lineTo(-inner_zone_width / 2, -inner_zone_height / 2)

zone_shape.holes.push(hole)

const zone_depth = 0.1
const extrude_settings = {
    depth: zone_depth,
    bevelEnabled: false,
    // bevelSegments: 2,
    steps: 2,
    // bevelSize: 0.1,
    // bevelThickness: 1,
}
const zone_geometry = new THREE.ExtrudeGeometry(zone_shape, extrude_settings)
zone_geometry.rotateX(Math.PI / 2)

export default class StrikeZone {
    constructor() {
        this.object = new THREE.Mesh(
            zone_geometry,
            new THREE.MeshPhongMaterial({ color: 0x3caa3d })
        )
        this.object.position.y = -2.75 + zone_depth
        this.object.position.z = zone_center
    }
}
